import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeSideBar, logoutUser, toggleFilterSidebar } from '../action'
import { BsBag } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import { FiUser, FiLogOut, FiSettings, FiMenu, FiSearch } from 'react-icons/fi'
import SearchBar from './SearchBar'

function Header() {
  const dispatch = useDispatch()
  const { user, isAuthenticated, cart, filterSidebarOpen } = useSelector(state => state)
  const [isScrolled, setIsScrolled] = useState(false)
  const [showUserMenu, setShowUserMenu] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const toggleUserMenu = () => setShowUserMenu(!showUserMenu)
  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen)

  const handleLogout = () => {
    dispatch(logoutUser())
    setShowUserMenu(false)
    setMobileMenuOpen(false)
  }

  const handleCartSidebar = () => dispatch(changeSideBar())
  const handleFilterSidebar = () => dispatch(toggleFilterSidebar())

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 60)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header className={`vintage-header fixed w-full z-20 transition-all duration-300 ${isScrolled ? 'shadow-lg py-1' : 'py-2'}`}>
  <div className="w-full max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* LEFT: Menú filtro + Logo vintage */}
        <div className="flex items-center gap-6">
          <button
            onClick={handleFilterSidebar}
            className="vintage-filter-btn icon-only group"
          >
            <FiMenu className={`text-xl group-hover:scale-110 transition-transform duration-200 ${filterSidebarOpen ? 'rotate-90' : ''}`} />
          </button>
          <Link to="/" className="sr-only">
            <span className="font-vintage-title text-xl sm:text-2xl text-slate-900 tracking-wide">
              DISTRIBUIDOR MARCIAL
            </span>
          </Link>
        </div>

        {/* CENTER: Search bar en md+ */}
        <div className="hidden md:block w-1/3">
          <SearchBar />
        </div>

        {/* Solo mostrar en mobile (hasta md) */}
        <div className="block md:hidden">
          <Link to="/" className="flex items-center">
            <span className="font-vintage-title font-bold text-base text-slate-900 tracking-wide leading-tight">
               MARCIAL
            </span>
          </Link>
        </div>


        {/* RIGHT: Usuario + carrito + menú móvil */}
  <div className="flex items-center gap-2 sm:gap-4">
          {/* Usuario vintage (solo en md+) */}
          <div className="hidden md:flex items-center gap-4">
            {isAuthenticated ? (
              <div className="relative">
                <button
                  onClick={toggleUserMenu}
                  className="vintage-filter-btn flex items-center gap-2 px-3 py-2"
                >
                  <FiUser className="text-lg" />
                  <span className="font-medium">{user?.firstName}</span>
                </button>
                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-48 bg-white border border-slate-200 rounded shadow-xl py-2 z-50 animate-fadeIn">
                    <div className="px-4 py-2 text-sm text-slate-800 border-b border-slate-200 font-medium">
                      {user?.firstName} {user?.lastName}
                    </div>
                    {user?.role === 'admin' && (
                      <Link
                        to="/admin"
                        className="flex items-center px-4 py-2 text-sm text-slate-700 hover:bg-slate-800 hover:text-white transition"
                        onClick={() => setShowUserMenu(false)}
                      >
                        <FiSettings className="mr-2" /> Panel Admin
                      </Link>
                    )}
                    <button
                      onClick={handleLogout}
                      className="flex items-center w-full px-4 py-2 text-sm text-slate-700 hover:bg-slate-800 hover:text-white transition"
                    >
                      <FiLogOut className="mr-2" /> Cerrar Sesión
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <>
                <Link to="/login" className="vintage-filter-btn px-4 py-2">Iniciar Sesión</Link>
                <Link to="/register" className="btn-vintage px-6 py-2 transform hover:scale-105 shadow-md hover:shadow-lg">Registrarse</Link>
              </>
            )}
          </div>

          {/* Carrito vintage */}
          <div
            onClick={handleCartSidebar}
            className="relative cursor-pointer vintage-filter-btn icon-only group"
          >
            <BsBag className="text-2xl transition-transform group-hover:scale-110" />
            <div className="absolute top-0 right-0 sm:-top-1 sm:-right-1 bg-slate-800 text-white text-[10px] w-5 h-5 rounded-full flex items-center justify-center shadow-md">
              {cart.length}
            </div>
          </div>

          {/* Menú móvil */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden inline-flex items-center justify-center vintage-filter-btn icon-only"
            aria-label="Buscar"
          >
            <FiSearch className="text-2xl transition-transform group-hover:scale-110" />
          </button>
        </div>
      </div>

      {/* MENÚ MÓVIL */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-200 py-4 px-6 shadow-lg animate-fadeIn">
          <SearchBar />
          <div className="mt-4 space-y-2">
            {isAuthenticated ? (
              <>
                <div className="text-slate-800 font-medium font-vintage-display">
                  {user?.firstName} {user?.lastName}
                </div>
                {user?.role === 'admin' && (
                  <Link
                    to="/admin"
                    className="block vintage-filter-btn px-3 py-2 w-full text-left"
                    onClick={toggleMobileMenu}
                  >
                    Panel Admin
                  </Link>
                )}
                <button
                  onClick={handleLogout}
                  className="vintage-filter-btn px-3 py-2 w-full text-left"
                >
                  Cerrar Sesión
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="block vintage-filter-btn px-3 py-2 w-full text-center"
                  onClick={toggleMobileMenu}
                >
                  Iniciar Sesión
                </Link>
                <Link
                  to="/register"
                  className="block btn-vintage px-4 py-2 text-center transform hover:scale-105 shadow-md hover:shadow-lg"
                  onClick={toggleMobileMenu}
                >
                  Registrarse
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  )
}

export default Header
